"use client";

import { CSPostHogProvider } from "./providers";

// Client components still render their children on the server. Only analytics
// initialization belongs in an effect; it must not gate the application shell.
export default function PostHogProviderClient({
  children,
  bootstrapData,
}: {
  children: React.ReactNode;
  bootstrapData?: any;
  // Retained for existing layout callers; both paths render their children
  // on the server while analytics initialization stays inside effects.
  guestUpload?: boolean;
}): React.JSX.Element {
  return (
    <CSPostHogProvider bootstrapData={bootstrapData}>
      {children}
    </CSPostHogProvider>
  );
}
